export const MONTHLY_GOAL_DEFAULTS={
  1:{goal:400000,consultantGoal:100000},2:{goal:400000,consultantGoal:100000},
  3:{goal:400000,consultantGoal:180000},4:{goal:400000,consultantGoal:120000},
};
export function monthlyGoalRange(month){
  const [year,number]=String(month).split("-").map(Number);
  return {from:new Date(year,number-1,1),to:new Date(year,number,0,23,59,59,999)};
}
export function storesWithMonthlyGoals(stores,month,settings={}){
  return stores.map(store=>{
    if(!MONTHLY_GOAL_DEFAULTS[store.id])return store;
    const values=settings[store.id]||(month>="2026-10"?MONTHLY_GOAL_DEFAULTS[store.id]:null);
    if(!values)return store;
    // Preserve existing super-goal ratios, not a lower obsolete absolute target.
    return {...store,goal:values.goal,consultantGoal:values.consultantGoal,
      superGoal:Math.round(values.goal*(store.superGoal/store.goal)),
      consultantSuperGoal:Math.round(values.consultantGoal*(store.consultantSuperGoal/store.consultantGoal))};
  });
}
